import { ActionTypes } from '../constants/ActionTypes';

export const account = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.LOGIN:
            if (action.account.token !== "") {
                return action.account;
            }
    }
    return state;
}

export const token = (state = "", action) => {
    switch (action.type) {
        case ActionTypes.GET_TOKEN:
            if (action.token !== "") {
                return action.token;
            }
        case ActionTypes.REMOVE_TOKEN:
            return "";
    }
    return state;
}

export default account;


// WEBPACK FOOTER //
// ./src/reducers/auth.js